import type { HepatoForm } from '../api/hepatoApi';
import type { Patient } from '../api/patientApi';
import { apiClient } from '../api/axios';
import { downloadPdf } from './pdfDownload';

export async function generateHepatoPdfFromTemplate(form: HepatoForm, _patient: Patient): Promise<Uint8Array> {
  const response = await apiClient.get(`/hepato-forms/${form.id}/export.pdf`, {
    responseType: 'arraybuffer',
  });

  return new Uint8Array(response.data);
}

export function buildHepatoPdfFilename(patient: Patient): string {
  const clean = (value: string) => value.replace(/[^\w-]+/g, '_').replace(/^_+|_+$/g, '');
  const date = new Date().toISOString().split('T')[0];
  return `HEPATO_ANAMNEZA_${clean(patient.lastName)}_${clean(patient.firstName)}_${date}.pdf`;
}

export { downloadPdf };
